import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';

/** Real inside pages — shown right after the hero CTA. */
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-105" data-mp="2h53r24rlw67y">
      <div className="mx-auto max-w-6xl" data-id="element-106" data-mp="2d4bizeuh07d9">
        <SectionHeading id="inside-heading" title={<>
              Ce n’est pas un ebook à lire. <Accent data-id="element-108" data-mp="23640usog3j9o">C’est un système à utiliser.</Accent>
            </>} data-id="element-107" data-mp="285qidebb3loa" />

        <div className="mt-12" data-id="element-109" data-mp="1y70wlagahh2r">
          <InsidePagesCarousel data-id="element-110" data-mp="1y8c1jdlh0uvg" />
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.7rem] font-bold leading-snug text-brand-charcoal sm:text-[2rem]" data-id="element-111" data-mp="1u5yxctmdh50s">
          Des outils pour vos cours.
          <span className="block" data-id="element-112" data-mp="3sjh9gu3lbtgl">
            <Accent data-id="element-113" data-mp="3ojgosrpwem13">Pas seulement du contenu à lire.</Accent>
          </span>
        </p>
      </div>
    </section>;
}